import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM15.7072 10.7071C16.0977 10.3165 16.0976 9.68334 15.7071 9.29284C15.3165 8.90235 14.6833 8.90239 14.2928 9.29294L11.0004 12.5858L9.70701 11.2928C9.31643 10.9023 8.68326 10.9024 8.29279 11.293C7.90232 11.6836 7.90241 12.3167 8.29299 12.7072L10.2936 14.7072C10.6841 15.0977 11.3172 15.0976 11.7077 14.7071L15.7072 10.7071Z",
      fill: "#00824B"
    }, null, -1)
  ])))
}
export default { render: render }